// 기본 경고 이미지
const DEFAULT_PIN = 'https://blog.kakaocdn.net/dn/pfZ5m/btsqFtVWV5K/Y2dpzqQ1zPLwM2Fa70juwK/img.png';
const SELECTED_PIN =
  'https://blog.kakaocdn.net/dn/uAYjA/btsqCtWGKbC/7NEWoFyJTfKqG9arFQB0F1/img.png';

export { DEFAULT_PIN, SELECTED_PIN };
